import {
  type SecuritySchemaNode,
  isRuleNode,
} from 'components/SecuritySchema/model/SecuritySchemaNode';

/**
 * Wrap each run of rules sharing a cloud policy in a `policy` box. An
 * enforcement point merges its policies into one chain, so grouping consecutive
 * runs shows the owner without disturbing evaluation order. Nodes with no
 * policy — every on-prem rule, and the default action — pass through, so no
 * other tree changes shape.
 */
export const groupRulesByCloudPolicy = (
  nodes: SecuritySchemaNode[],
): SecuritySchemaNode[] =>
  nodes.reduce<SecuritySchemaNode[]>((grouped, node) => {
    const policy = isRuleNode(node) ? node.cloudPolicy : undefined;
    if (policy === undefined) {
      grouped.push(node);
      return grouped;
    }
    const last = grouped[grouped.length - 1];
    if (last?.type === 'policy' && last.policy.id === policy.id) {
      last.children.push(node);
      return grouped;
    }
    grouped.push({ type: 'policy', policy, children: [node] });
    return grouped;
  }, []);
